/**
 * Map a CRM deal to a power-dialer queue item. Skips deals without a phone
 * number (returns null). Combine with .filter(Boolean) when mapping arrays.
 *
 * @param {Object} deal - CRM deal row
 * @param {Object} stageMap - { stageId: stage } lookup for stage name
 * @returns {Object|null}
 */
export function mapDealToDialerQueue(deal, stageMap) {
	const phone = deal.primaryContactPhone || deal.companyPhoneNumber;
	if (!phone) return null;
	return {
		dealId: deal.id,
		companyName: deal.companyNameSnapshot,
		contactName: deal.primaryContactName,
		phoneNumber: phone,
		companyId: deal.crmCompanyId,
		dealTitle: deal.title,
		dealValue: deal.dealValue,
		closingChance: deal.closingChance,
		stageName: stageMap[deal.stageId]?.name ?? null,
		ownerName: deal.users?.[0]?.fullName ?? deal.users?.[0]?.emailAddress ?? null,
	};
}
